export default __webpack_public_path__ + "static/media/hangman_demo_image.79e4cfb2.png";